import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BASE_URI, config } from 'app/app.config';

@Injectable({
  providedIn: 'root'
})
export class AgentServiceService {

  private baseUrl = BASE_URI.URL;

  constructor(
    private http: HttpClient
  ) { }


  getCustomVoice() {
    return this.http.get(`${this.baseUrl}/customVoice`)
  }

  selectAIAgent(payload:any) {
    return this.http.put(`${this.baseUrl}/agent`, payload)
  }


  preHttpParams(payLoad: any) {
    let Params = new HttpParams();
    for (const key in payLoad) {
      if (key && (payLoad[key] || payLoad[key] === 0)) {
        Params = Params.append(key, payLoad[key]);
      }
    }
    return Params;
  }
}
